var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "v-form",
    { on: { prevent: _setup.submit } },
    [
      _c(_setup.TipTap, {
        attrs: {
          characterLimit: 2048,
          icon: "save",
          valid: "",
          disabled: _setup.props.disabled,
        },
        on: { submit: _setup.submit },
        model: {
          value: _setup.form.crm_note,
          callback: function ($$v) {
            _vm.$set(_setup.form, "crm_note", $$v)
          },
          expression: "form.crm_note",
        },
      }),
      _vm._v(" "),
      _c("v-input", {
        staticClass: "px-6",
        attrs: {
          "error-messages": _vm.errors.crm_note,
          "hide-details": "auto",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }